module.exports = "/packs/media/images/pointstime-e189032f6d133f53820a260e4dcc42df.png";